<template>
  <div class="personal-custom-menu-list">
    <draggable
      tag="div"
      class="draggable-list"
      handle=".drag-btn"
      filter=".is-disabled"
      :group="`${dataKey}-personal-menu-group`"
      :list="value"
    >
      <div
        v-for="(menuGroup, index) in value"
        class="list-group"
        :key="menuGroup._vid"
      >
        <div class="list-name">
          <div class="drag-btn" :class="isDisabled && 'is-disabled'">
            <i class="iconfont iconMore"></i>
          </div>
          <el-input v-if="menuGroup.isDefault" :value="$t(menuGroup.nameI18nKey)" :disabled="isDisabled || menuGroup.isDefault"></el-input>
          <el-input v-else v-model="menuGroup.name" class="menu-group-name" :class="!menuGroup.name && isError[menuGroup._vid] && 'is-error'" :disabled="isDisabled || menuGroup.isDefault" :placeholder="$t(`${i18nPrefix}.label.menuGroupName`)" @focus="handleFocus(menuGroup._vid)"></el-input>
          <el-switch v-model="menuGroup.isActive" class="active-switch" :disabled="isDisabled" @change="handleMenuGroupActiveChange($event, menuGroup)"></el-switch>
          <el-checkbox v-model="menuGroup.onlyEmployee" :disabled="isDisabled" @change="handleMenuGroupVisibleStatusChange($event, menuGroup)">{{ $t(`${i18nPrefix}.label.onlyEmployee`) }}</el-checkbox>
          <i v-if="!menuGroup.isDefault" class="delete-btn iconfont iconRemove" :class="isDisabled && 'is-disabled'" @click="handleDeleteMenuGroup(index)"></i>
        </div>
        <draggable
          tag="div"
          class="draggable-list"
          handle=".drag-btn"
          filter=".is-disabled"
          :group="`${dataKey}-personal-menu-list`"
          :list="menuGroup.children"
        >
          <div v-for="(menu, menuIndex) in menuGroup.children" class="menu-item" :key="`${menuGroup._vid}-${menu._vid}`">
            <div class="container-wrapper">
              <div class="drag-btn" :class="isDisabled && 'is-disabled'">
                <i class="iconfont iconMore"></i>
              </div>
              <div class="content">
                <el-input v-if="menu.isDefault" :value="$t(menu.labelI18nKey)" :disabled="isDisabled || menu.isDefault"></el-input>
                <el-input v-else v-model="menu.label" class="menu-name" :class="!menu.label && isError[`${menuGroup._vid}-${menu._vid}`] && 'is-error'" :disabled="isDisabled || menu.isDefault" :placeholder="$t(`${i18nPrefix}.label.name`)" @focus="handleFocus(`${menuGroup._vid}-${menu._vid}`)"></el-input>
              </div>
              <div v-if="!menu.isDefault" class="content">
                <el-input v-model="menu.link" class="menu-link" :class="!menu.link && isError[`${menuGroup._vid}-${menu._vid}`] && 'is-error'" :disabled="isDisabled" :placeholder="$t(`${i18nPrefix}.label.link`)" @focus="handleFocus(`${menuGroup._vid}-${menu._vid}`)"></el-input>
              </div>
              <div class="btn-group">
                <el-switch v-model="menu.isActive" :disabled="isDisabled" @change="handleMenuActiveChange($event, menuGroup, menu)"></el-switch>
                <el-checkbox v-model="menu.onlyEmployee" :disabled="isDisabled || menu.disableChange" @change="handleMenuVisibleStatusChange($event, menuGroup, menu)">{{ $t(`${i18nPrefix}.label.onlyEmployee`) }}</el-checkbox>
                <i v-if="!menu.isDefault && menuGroup.children.length > 1" class="delete-btn iconfont iconRemove" :class="isDisabled && 'is-disabled'" @click="handleDeleteMenu(menuGroup, menuIndex)"></i>
                <i class="add-btn iconfont iconAdd1"  :class="isDisabled && 'is-disabled'"  @click="handleAddMenu(menuGroup, menuIndex, index)"></i>
              </div>
            </div>
          </div>
        </draggable>
        <el-divider v-if="index !== value.length - 1"></el-divider>
      </div>
    </draggable>
    <div>
      <el-button class="add-new-line-btn" size="small" type="primary" :disabled="isDisabled" @click="handleAddMenuGroup">{{ $t(`${i18nPrefix}.btn.addNewLine`) }}</el-button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  props: {
    value: {
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    dataKey: {
      type: String,
      required: true
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      i18nPrefix: 'admin.company.customCompanyTheme',
      menuGroupVid: 0,
      menuVidMap: {},
      isError: {}
    }
  },
  mounted () {
    this.menuGroupVid = this.value.length
    _.forEach(this.value, (item, index) => {
      this.menuVidMap[index] = item.children.length
    })
  },
  methods: {
    handleDeleteMenuGroup (index) {
      this.value.splice(index, 1)
    },
    handleDeleteMenu (menuGroup, menuIndex) {
      menuGroup.children.splice(menuIndex, 1)
    },
    handleAddMenu (menuGroup, menuIndex, index) {
      this.menuVidMap[index]++
      menuGroup.children.splice(menuIndex + 1, 0, {
        _vid: this.menuVidMap[index],
        label: '',
        link: '',
        isActive: false,
        onlyEmployee: false
      })
    },
    handleAddMenuGroup () {
      this.menuGroupVid++
      this.menuVidMap[this.menuGroupVid] = 1
      this.value.push({
        _vid: this.menuGroupVid,
        name: '',
        isActive: false,
        onlyEmployee: false,
        children: [{
          _vid: this.menuVidMap[this.menuGroupVid],
          label: '',
          link: '',
          isActive: false,
          onlyEmployee: false
        }]
      })
    },
    handleMenuGroupActiveChange (status, menuGroup) {
      if (status) {
        if (!menuGroup.isDefault && !_.trim(menuGroup.name)) {
          this.isError[menuGroup._vid] = true
          this.$message.error(this.$t(`${this.i18nPrefix}.message.fieldIsRequired`))
          menuGroup.isActive = false
          return
        }
        _.forEach(menuGroup.children, item => {
          if (item.isDefault || (_.trim(item.label) && _.trim(item.link))) {
            item.isActive = true
          }
        })
      } else {
        _.forEach(menuGroup.children, item => {
          item.isActive = false
        })
      }
    },
    handleMenuGroupVisibleStatusChange (status, menuGroup) {
      _.forEach(menuGroup.children, item => {
        if (item.disableChange) {
          return
        }
        item.onlyEmployee = status
      })
    },
    handleMenuActiveChange (status, menuGroup, menu) {
      if (status) {
        if (!menuGroup.isDefault && !_.trim(menuGroup.name)) {
          this.isError[menuGroup._vid] = true
          menuGroup.isActive = false
        } else {
          menuGroup.isActive = true
        }
        if (!menu.isDefault && (!_.trim(menu.label) || !_.trim(menu.link))) {
          this.isError[`${menuGroup._vid}-${menu._vid}`] = true
          menu.isActive = false
        }
        if (!menuGroup.isActive || !menu.isActive) {
          this.$message.error(this.$t(`${this.i18nPrefix}.message.fieldIsRequired`))
          menu.isActive = false
        }
      } else {
        if (!_.some(menuGroup.children, 'isActive')) {
          menuGroup.isActive = false
        }
      }
    },
    handleMenuVisibleStatusChange (status, menuGroup, menu) {
      if (status) {
        if (!_.some(menuGroup.children, ['onlyEmployee', false])) {
          menuGroup.onlyEmployee = true
        }
      } else {
        menuGroup.onlyEmployee = false
      }
    },
    handleFocus (key) {
      this.isError[key] = false
    }
  }
}
</script>

<style lang="scss" scoped>
.personal-custom-menu-list {
  .list-group {
    .list-name {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .label {
        flex-shrink: 0;
        margin-right: 10px;
        width: 70px;
        text-align: center;
      }

      .el-input {
        width: 432px;
        margin-right: 10px;
      }

      .active-switch {
        margin-right: 10px;
      }

      .menu-group-name {
        &.is-error {
          ::v-deep {
            .el-input__inner {
              border-color: #f56c6c;
            }
          }
        }
      }

      .delete-btn {
        margin-right: 10px;
        color: red;
        cursor: pointer;
        vertical-align: middle;

        &.is-disabled {
          cursor: not-allowed;
          color: rgba($color: red, $alpha: 0.7)
        }
      }

      .el-checkbox {
        margin-right: 10px;
      }
    }

    .draggable-list {
      margin-left: 34px;
    }
  }

  .menu-item {
    margin-bottom: 10px;

    .container-wrapper {
      display: flex;
      align-items: center;
      min-width: 750px;
    }

    .el-divider {
      margin: 6px 0;
    }

    .content {
      display: flex;
      align-items: center;
      margin-right: 10px;

      .label {
        flex-shrink: 0;
        text-align: center;
        width: 36px;
        margin-right: 10px;
      }

      .menu-name, .menu-link {
        &.is-error {
          ::v-deep {
            .el-input__inner {
              border-color: #f56c6c;
            }
          }
        }
      }
    }

    .btn-group {
      .el-switch {
        margin-right: 10px;
      }

      .el-checkbox {
        margin-right: 10px;
      }

      .delete-btn {
        margin-right: 10px;
        color: red;
        cursor: pointer;
        vertical-align: middle;

        &.is-disabled {
          cursor: not-allowed;
          color: rgba($color: red, $alpha: 0.7)
        }
      }

      .add-btn {
        color: #0096cc;
        cursor: pointer;
        vertical-align: middle;

        &.is-disabled {
          cursor: not-allowed;
          color: rgba($color: #0096cc, $alpha: 0.7)
        }
      }
    }
  }

  .drag-btn {
    margin-right: 10px;
    width: 16px;
    cursor: pointer;

    &.is-disabled {
      cursor: not-allowed;
    }
  }
}

.page-en {
  .list-group {
    .list-name {
      .label {
        width: 88px;
      }

      .el-input {
        width: 432px;
      }
    }

    .draggable-list {
      margin-left: 46px;

      .container-wrapper {
        .content {
          .label {
            width: 42px;
          }
        }
      }
    }
  }
}
</style>
